import {  CHANGE_WALLET_STATUS } from "./constants";
const defaultState = {
   walletStatus: 0,
   walletAddress: ""
}
function ethChainReducer(state = defaultState, action) {
   switch (action.type) {
      case CHANGE_WALLET_STATUS:
            if(action.code===0){
               window.localStorage.setItem("wallet_provider", "all");
            }
            return {...state,walletAddress:action.address,walletStatus:action.code}
      default:
         return state;
   }
}
export default ethChainReducer;
